/**
 * Amount placeholder while data is still loading (BUG-008 / DEV-320).
 *
 * Benefits views used to render "$0.00" before enrollments/rates arrived,
 * which reads as "this employee pays nothing". Render a dash instead until
 * the number is real.
 */
export const LOADING_AMOUNT_PLACEHOLDER = "—";

export function amountOrPlaceholder(loading: boolean, format: () => string): string {
  return loading ? LOADING_AMOUNT_PLACEHOLDER : format();
}
